// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Header-module--cds--assistive-text--2d64a";
export var cdsHideFeedback = "Header-module--cds--hide-feedback--bd91b";
export var cdsShowFeedback = "Header-module--cds--show-feedback--47234";
export var cdsSkeleton = "Header-module--cds--skeleton--d6dcd";
export var cdsVisuallyHidden = "Header-module--cds--visually-hidden--8b0c1";
export var header = "Header-module--header--d5120";
export var headerButton = "Header-module--header-button--ebb2a";
export var headerName = "Header-module--headerName--3b600";
export var headerNameWithHeaderNav = "Header-module--headerNameWithHeaderNav--981b5";
export var headerWithHeaderNav = "Header-module--headerWithHeaderNav--87c30";
export var searchIsOpenOnBar = "Header-module--searchIsOpenOnBar--396d4";
export var searchIsOpenOnLink = "Header-module--searchIsOpenOnLink--2cd47";
export var skipToContent = "Header-module--skip-to-content--f3642";
export var switcherButton = "Header-module--switcher-button--3ae5b";
export var switcherButtonOpen = "Header-module--switcher-button--open--b41bf";